import React from 'react';
import clsx from 'clsx';

import { Text } from '@auspost/postmaster-react';

import { CommonClass } from 'config/track-config';
import { CustomerAuthLevel } from 'models/Customer';
import { selectAuthLevel } from 'store/customer';
import { useAppSelector } from 'store/store';

import { useCurrentArticle, useFirstArticle, useShipment } from '../../hooks/shipment.hooks';
import { SENDER_LOCATION_TEST_ID } from './SenderLocation.test-ids';

import styles from './SenderLocation.module.scss';

export const SenderLocation: React.FC = () => {
  const merchantName = useShipment()?.merchant?.displayName ?? '';
  const sender = useFirstArticle()?.sender ?? '';
  const fromAddress = useCurrentArticle()?.fromAddress;
  const isAnon = useAppSelector(selectAuthLevel) === CustomerAuthLevel.ANONYMOUS;

  let displaySender = '';
  if (!isAnon && merchantName) {
    displaySender = merchantName;
  } else if (fromAddress) {
    const { internationalAddress = false, country = '', state = '' } = fromAddress;
    const location = (internationalAddress ? country : state) ?? '';
    displaySender = sender && location ? `${sender}, ${location}` : `${sender}${location}`;
  }

  return (
    <>
      {displaySender && (
        <Text
          variant='body-small'
          className={clsx(styles.senderLocation, CommonClass.FULLSTORY_MASK)}
          data-testid={SENDER_LOCATION_TEST_ID}
        >
          <b>From</b> {displaySender}
        </Text>
      )}
    </>
  );
};

export default SenderLocation;
